import type { ReactNode } from 'react';

import type {
  ToolExtensionOptions,
  ToolGroupEntry,
  ToolIconRenderOptions,
} from '../../extensions/tool-extension';
import { inferToolIcon } from './defaultToolMappings';

export const ToolIcon = ({
  entry,
  extension,
  size,
  className,
  isStreaming,
}: ToolIconRenderOptions & {
  entry: ToolGroupEntry;
  extension: ToolExtensionOptions | undefined;
}): ReactNode => {
  const IconComponent = extension?.icon ?? inferToolIcon(entry.tool);

  return (
    extension?.renderIcon?.(entry, {
      size,
      className,
      isStreaming: entry.isStreaming ?? isStreaming,
    }) ?? <IconComponent size={size} className={className} />
  );
};
